import { useEffect, useState } from "react";
import { Card, Progress, Spin, Tag } from "antd";
import {
   TrophyOutlined,
   CheckCircleOutlined,
   ClockCircleOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";

import { getSalesTargetProgress } from "../../services/salesTargetService";

const SalesTargetCard = () => {

   const [loading, setLoading] = useState(true);
   const [target, setTarget] = useState(null);


   const fetchTarget = async () => {

      try {

         setLoading(true);

         const data = await getSalesTargetProgress();
         console.log(data)

         setTarget(data);

      } catch (err) {

         console.error(err);

      } finally {

         setLoading(false);

      }

   };

   useEffect(() => {
      fetchTarget();
   }, []);

   useEffect(() => {
      if (target) {
         console.log(target);
      }
   }, [target]);


   if (loading) {
      return (
         <Card>
            <Spin />
         </Card>
      );
   }

   if (!target || target.message) {

      return (
         <Card title="Sales Target">
            No active target found.
         </Card>
      );

   }



   return (
      <Card
         bordered={false}
         style={{
            borderRadius: 12,
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)"
         }}
         title={
            <div className="flex items-center justify-between">
               <div className="flex items-center gap-2">
                  <TrophyOutlined
                     style={{
                        color: "#faad14",
                        fontSize: 18
                     }}
                  />
                  <span className="font-semibold text-gray-800">
                     Current Sales Target
                  </span>
               </div>

               <Tag
                  color={
                     target.commission_status === "Eligible"
                        ? "green"
                        : "orange"
                  }
                  style={{
                     padding: "2px 10px",
                     borderRadius: 20,
                     fontWeight: 500
                  }}
               >
                  {target.commission_status}
               </Tag>
            </div>
         }
      >
         {/* Hero */}
         <div className="text-center mb-8">

            <div
               style={{
                  fontSize: 40,
                  fontWeight: 700,
                  color:
                     target.achievement_percentage >= 100
                        ? "#22c55e"
                        : "#16a34a"
               }}
            >
               ₹ {Number(target.achieved_amount).toLocaleString("en-IN")}
            </div>

            <div
               style={{
                  color: "#6b7280",
                  fontSize: 15,
                  marginTop: 4
               }}
            >
               Achieved Amount
            </div>

         </div>

         {/* Progress */}
         <div className="mb-7">

            <div className="flex justify-between items-center mb-2">

               <span className="text-gray-500">
                  Achievement
               </span>

               <span
                  style={{
                     fontWeight: 600,
                     color:
                        target.achievement_percentage >= 100
                           ? "#22c55e"
                           : "#1677ff"
                  }}
               >
                  {target.achievement_percentage}% Completed
               </span>

            </div>

            <Progress
               percent={target.achievement_percentage}
               showInfo={false}
               strokeColor={
                  target.achievement_percentage >= 100
                     ? "#22c55e"
                     : target.achievement_percentage >= 50
                        ? "#faad14"
                        : "#1677ff"
               }
               strokeWidth={10}
            />

         </div>

         {/* Stats */}
         <div className="grid grid-cols-3 gap-6">

            <div>
               <div className="text-gray-500 text-sm mb-1">
                  Target
               </div>

               <div className="font-bold text-xl">
                  ₹ {Number(target.target_amount).toLocaleString("en-IN")}
               </div>
            </div>

            <div>
               <div className="text-gray-500 text-sm mb-1">
                  Balance Target
               </div>

               <div
                  className="font-bold text-xl"
                  style={{ color: "#2563eb" }}
               >
                  ₹ {Number(target.remaining_amount).toLocaleString("en-IN")}
               </div>
            </div>

            <div>
               <div className="text-gray-500 text-sm mb-1">
                  Commission
               </div>

               <div className="font-bold text-xl">
                  ₹ {Number(target.commission_amount).toLocaleString("en-IN")}
               </div>

               <Tag
                  color={
                     target.commission_status === "Eligible"
                        ? "green"
                        : "orange"
                  }
                  style={{ marginTop: 8 }}
               >
                  {target.commission_status}
               </Tag>
            </div>

         </div>

         {/* Target Period */}
         <div
            style={{
               marginTop: 28,
               paddingTop: 18,
               borderTop: "1px solid #f0f0f0"
            }}
         >

            <div className="text-gray-500 text-sm">
               Target Period
            </div>

            <div
               style={{
                  marginTop: 4,
                  fontWeight: 500
               }}
            >
               {dayjs(target.target.start_date).format("DD MMM YYYY")}
               {"  "}→{"  "}
               {dayjs(target.target.end_date).format("DD MMM YYYY")}
            </div>

         </div>

         {/* Success Message */}
         {target.commission_status === "Eligible" && (
            <div
               style={{
                  marginTop: 20,
                  padding: 12,
                  borderRadius: 8,
                  background: "#f6ffed",
                  border: "1px solid #b7eb8f",
                  color: "#389e0d",
                  textAlign: "center",
                  fontWeight: 600
               }}
            >
               🎉 Congratulations! You have achieved your sales target.
            </div>
         )}

      </Card>
   );
};

export default SalesTargetCard;